import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { ClientKind, TinKind } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';
import { OrderDirection, PagedCollectionQuery, PagedCollectionQueryResult, PagedCollectionQueryResultDTO } from './../../common/query/paged-collection-query';

export type ClientQLCollectionItem = ClientQLCollectionItemDTO;

class ClientQLCollectionItemDTO {
    public readonly favourite: boolean;
    public readonly version: string;
    public readonly id: number;
    public readonly name: string;
    public readonly tin: string;
    public readonly tinKind: TinKind;
    public readonly address: string;
    public readonly zipCode: string;
    public readonly city: string;
    public readonly country: string;
    public readonly groupId: number;
    public readonly kind: ClientKind;
    public readonly externalId: string;
};

export interface ClientQLQueryParams {
    id: number;
}

export class ClientQLCollectionQuery extends PagedCollectionQuery<ClientQLCollectionItem> { }

export class ClientQLCollectionQueryHandlerBase implements QueryHandler<ClientQLCollectionQuery, PagedCollectionQueryResult<ClientQLCollectionItem>> {
    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: ClientQLCollectionQuery, params: Partial<ClientQLQueryParams>): Promise<PagedCollectionQueryResult<ClientQLCollectionItem>> {
        const url = params && params.id ? TaggedUrl.join(fillPlaceholders('clients/:id', { id: params.id }), [Tags.Api]) : TaggedUrl.join('clients', [Tags.Api]);
        const queryParams = {
            ...query.params,
            orderBy: [`favourite+${OrderDirection.Desc}`, `name+${OrderDirection.Asc}`]
        };
        if (params?.id) {
            const { data } = await this.http.get(url, {
                params: queryParams,
                dto: ClientQLCollectionItemDTO
            });
            return {
                totalItemsCount: 1,
                items: [data]
            };
        } else {
            const { data } = await this.http.get(url, {
                params: queryParams,
                dtoObject: new PagedCollectionQueryResultDTO<ClientQLCollectionItemDTO>(ClientQLCollectionItemDTO)
            });
            return {
                totalItemsCount: data.totalItemsCount,
                items: data.items
            };

        }
    }
}
